import {
    createExoSafeLinksPolicy,
    updateExoSafeLinksPolicy,
} from 'projects/angular-clarity/src/app/stores/client/powershell/exo/safe-links-policy/actions';
import { SafeLinksPolicy } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/safe-links-policy/model';

export function Remediate(_tenant: string, data: SafeLinksPolicy[], schema: any) {
    const props = schema?.contains?.properties;
    const policyData: Partial<SafeLinksPolicy> = {
        Identity: props?.Identity?.const,
        Name: props?.Identity?.const,
        Priority: props?.Priority?.const,
        EnableSafeLinksForEmail: props?.EnableSafeLinksForEmail?.const ?? false,
        EnableForInternalSenders: props?.EnableForInternalSenders?.const ?? false,
        ScanUrls: props?.ScanUrls?.const ?? false,
        DeliverMessageAfterScan: props?.DeliverMessageAfterScan?.const ?? false,
        DoNotRewriteUrls: props?.DoNotRewriteUrls?.items?.enum ?? [],
        DisableUrlRewrite: props?.DisableUrlRewrite?.const ?? false,
        EnableSafeLinksForTeams: props?.EnableSafeLinksForTeams?.const ?? false,
        EnableSafeLinksForOffice: props?.EnableSafeLinksForOffice?.const ?? false,
        TrackClicks: props?.TrackClicks?.const ?? false,
        AllowClickThrough: props?.AllowClickThrough?.const ?? false,
        EnableOrganizationBranding: props?.EnableOrganizationBranding?.const ?? false,
        EnableMicrosoftTranslator: props?.EnableMicrosoftTranslator?.const ?? false,
        CustomNotificationText: props?.CustomNotificationText?.const ?? '',
        SentTo: props?.SentTo?.items?.enum ?? [],
        SentToMemberOf: props?.SentToMemberOf?.items?.enum ?? [],
        RecipientDomainIs: props?.RecipientDomainIs?.items?.enum ?? [],
        ExceptIfSentTo: props?.ExceptIfSentTo?.items?.enum ?? [],
        ExceptIfSentToMemberOf: props?.ExceptIfSentToMemberOf?.items?.enum ?? [],
        ExceptIfRecipientDomainIs: props?.ExceptIfRecipientDomainIs?.items?.enum ?? [],
    };

    const existingPolicy = data.find((res) => res.Identity === policyData.Identity);

    if (existingPolicy) {
        return updateExoSafeLinksPolicy({ _tenant, data: policyData });
    } else {
        return createExoSafeLinksPolicy({ _tenant, data: policyData });
    }
}
